import { ComponentType } from 'react';
import { useConfiguration } from '../store/Configuration';

// The Maps JS loader is a global singleton — constructed before the config fetch delivers the key, it poisons every map for the session.
export function withGoogleMapsApiKey<P extends object>(Component: ComponentType<P>) {
  const GoogleMapsApiKeyGate = (props: P) => {
    const { REACT_APP_GOOGLE_MAPS_API_KEY: googleMapsApiKey } = useConfiguration();

    if (!googleMapsApiKey) return null;

    return <Component {...props} />;
  };

  return GoogleMapsApiKeyGate;
}
